import Responses from "../../../../src/data/articles/the-first-four-questions-cube-designers-should-ask/Responses.tsx";
import QuestionHeading from "../../../../src/data/articles/the-first-four-questions-cube-designers-should-ask/QuestionHeading.tsx";
import MarkdownTemplate from "../../../../src/data/articles/the-first-four-questions-cube-designers-should-ask/MarkdownTemplate.tsx";
import * as React from 'react';
export default {
  Responses,
  QuestionHeading,
  MarkdownTemplate,
  React
};